import { LoginForm } from './login-form';
import classes from './index.module.css';
import { SeelEmail } from '../note';

const LoginText = {
  Title: 'Let’s start by tracking down your order details',
  Tip: 'Need help? Contact us at',
};

export const LoginPanel = () => (
  <section className={classes.panel_content}>
    <section className={classes.title}>{LoginText.Title}</section>
    <LoginForm />
    <section className={classes.tip}>
      <span>{LoginText.Tip}</span>
      <SeelEmail style={{ fontSize: '14px', lineHeight: '20px' }} />
    </section>
  </section>
);
